import React from "react";
import OrderDetail from "./views/OrderDetail";
import { OrderDetailContextProvider } from "./OrderDetailView";

const IntentOrderDetail = () => {
  return (
    <OrderDetailContextProvider>
      <OrderDetail />
    </OrderDetailContextProvider>
  );
};

export default IntentOrderDetail;
